import { render, staticRenderFns } from "./SpotLightList.vue?vue&type=template&id=37c2b11d&scoped=true&"
import script from "./SpotLightList.vue?vue&type=script&lang=js&"
export * from "./SpotLightList.vue?vue&type=script&lang=js&"
import style0 from "./SpotLightList.vue?vue&type=style&index=0&id=37c2b11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c2b11d",
  null
  
)

export default component.exports